import PropTypes from 'prop-types';
import React from 'react';

const ConfigureStageRunHeader: React.FC<ConfigureStageRunHeaderProps> = (
  props: ConfigureStageRunHeaderProps
): JSX.Element => (
  <div className="simpleDivTable-headerCell">
    <div className="u-small-spacing-bottom">
      <div>{props.text}</div>
    </div>
  </div>
);

interface ConfigureStageRunHeaderProps {
  text: string;
}

ConfigureStageRunHeader.propTypes = {
  text: PropTypes.string.isRequired,
};

export default ConfigureStageRunHeader;
